import { useEffect } from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Charts } from "../../components";
import useProductAnalyzerParams from "../../hooks/useProductAnalyzerParams";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getAveragesThunk } from "../../features/productAnalyzer/productAnalyzer.thunk";
import { selectProductAnalyzerSettings } from "../../features/settings/settings.selector";

const ViewCharts = () => {
  const dispatch = useAppDispatch();
  const { asin } = useProductAnalyzerParams();
  const { showPricesChart, showSoldChart, showOffersChart } = useAppSelector(
    selectProductAnalyzerSettings,
  );

  useEffect(() => {
    dispatch(getAveragesThunk(asin));
  });

  return (
    <Box>
      {!showPricesChart && !showSoldChart && !showOffersChart ? (
        <Typography variant="body1">
          All charts are disabled. Update chart{" "}
          <Link
            component={RouterLink}
            to="/settings/product-analyzer"
            underline="hover"
          >
            settings
          </Link>{" "}
          to view charts.
        </Typography>
      ) : (
        <Charts hideOpenNew />
      )}
    </Box>
  );
};

export default ViewCharts;
